export default "https://cdn-static.gokick.com/assets/f9e57853bbf9ca449046a7aa5fdd940e337957cb/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";